<div class="ltms-outbox-new-request-panel" [class.show]="newReqestPanelVisible">
    <div class="ltms-outbox-new-request-container">
        <div class="ltms-outbox-new-request-header">
            <div class="left-panel">
                <div class="outbox-request-tabs">
                    <div class="outbox-request-tab"
                        [ngClass]="{ 'outbox-request-active-tab': activeTab === 'single_request' }"
                        (click)="toggleTab('single_request')"> Single request</div>
                    <div class="outbox-request-tab"
                        [ngClass]="{ 'outbox-request-active-tab': activeTab === 'multiple_request' }"
                        (click)="toggleTab('multiple_request')">Multiple requests</div>
                </div>

            </div>
            <div class="right-panel">
                <button (click)="closeNewRequestPanel()">
                    <img src="assets/images/close.svg">
                </button>
            </div>
        </div>


        <div class="ltms-outbox-new-request-body">
            <!-- table-todo-->


            <div *ngIf="activeTab === 'single_request'">
                <app-outbox-single-request-creation></app-outbox-single-request-creation>
            </div>
            <div *ngIf="activeTab === 'multiple_request'" style="width: 100%;">
                <app-outbox-multi-request-creation></app-outbox-multi-request-creation>
            </div>
        </div>
    </div>
</div>